module.exports = __webpack_public_path__ + "img/l4.dafa2c68.png";